/**
 * NEUTRAL REPARTITION
 * Pure rule : the gauge of a topic counts the neutral answers with the positive ones (note >= 50).
 * To show them apart, split the repartition of its primary question (scale of 5 answers) :
 * negative (2 first classes), neutral (middle class), positive (2 last classes).
 * Only when the gauge of the topic comes from this single question : otherwise nothing is split.
 */

interface RepartitionQuestion {
  type: string
  responseCount: number
  repartition: number[]
  options?: { multipleItems?: boolean }
}

const sum = (values: number[]): number => values.reduce((total, value) => total + value, 0)

//Split a repartition of 5 classes in three scales : negative, neutral, positive (null if there are not 5 classes)
export function splitInThreeScales(repartition: number[]): [number, number, number] | null {
  if (repartition.length !== 5) return null
  const [one, two, three, four, five] = repartition
  return [one + two, three, four + five]
}

export function getNeutralRepartition(
  primary: RepartitionQuestion | null | undefined,
  scoredQuestionsCount: number,
  topicRepartition: number[]
): [number, number, number] | null {
  if (!primary || primary.type !== "scale" || primary.options?.multipleItems) return null
  if (primary.responseCount !== 5 || primary.repartition.length !== 5) return null
  if (scoredQuestionsCount !== 1) return null

  //The gauge of the topic must come from the same answers
  if (sum(primary.repartition) !== sum(topicRepartition)) return null

  return splitInThreeScales(primary.repartition)
}
